import { fansupportPrivate } from "../index";

export const getUserPoint = async () => {
    try {
        const response = await fansupportPrivate.get('/payment/user-points');
        return response;
    } catch (error) {
        console.log("getUserPoint",error);
    }
}